import { LoadingSpinner } from "@/components/loading-spinner";
import { Separator } from "@/components/separator";
import { FormProvider, useForm } from "react-hook-form";
import { ExperimentForm, type ExperimentFormValues, getExperimentFormDefaultValues } from "./components/ExperimentForm";
import { ExperimentTypeSelector } from "./components/ExperimentTypeSelector";
import { useExperimentData } from "./hooks/use-experiment-form";

export default function CreateExperimentPage() {
  const { experimentId, isEditing, currentExperiment, existingCampaigns, isDataReady } = useExperimentData();
  const defaultValues = getExperimentFormDefaultValues(currentExperiment, existingCampaigns);
  const formMethods = useForm<ExperimentFormValues>({
    defaultValues,
    values: defaultValues,
  });

  return (
    <>
      <Separator className="my-6" />

      {!isDataReady ? (
        <div className="flex justify-center items-center py-12">
          <LoadingSpinner />
        </div>
      ) : (
        <FormProvider {...formMethods}>
          <div className="mx-auto grid w-full max-w-4xl gap-6">
            <ExperimentTypeSelector disabled={isEditing} />
            <ExperimentForm
              key={experimentId || "new"}
              experimentId={experimentId}
              isEditing={isEditing}
              initialExperiment={currentExperiment}
              initialCampaigns={existingCampaigns}
              formMethods={formMethods}
              showExperimentTypeField={false}
            />
          </div>
        </FormProvider>
      )}
    </>
  );
}
